export default function CsharpProperties() {
  return (
    <h2>Csharp Properties</h2>
  );
}
